const getCustomerLink = ({ groupId, customerId }) => {
    if (groupId && customerId) return `/app/${groupId}/customer/${customerId}`;
    return '';
};

export default getCustomerLink;
